export const DATE_PICKER_DATE_BUTTON_TEST_ID = 'datePickerDateButton';
